import axiosInstance from '@/api/axiosInstance';

export type ChartOfAccountItem = {
  id: string;
  code: string;
  description: string;
  status: 'active' | 'inactive';
};

export interface ChartOfAccountsResponse {
  data: {
    data: ChartOfAccountItem[];
    total?: number;
  };
  success?: boolean;
  message?: string;
}

type FetchParams = {
  tenantId?: string;
  search?: string;
  limit?: number;
  offset?: number;
  status?: string;
};

export interface CreateChartOfAccountInput {
  code: string;
  description: string;
  createdByUserId?: string;
  status?: string;
}

export interface editChartOfAccountInput extends CreateChartOfAccountInput {
  id?: string;
  status: string;
}

export async function fetchChartOfAccounts(
  params: FetchParams = {}
): Promise<ChartOfAccountsResponse> {
  const { tenantId, search, limit, offset, status } = params;
  const response = await axiosInstance.get(
    '/api/v1/financial-settings/chart-of-account',
    {
      headers: { 'x-tenant-id': tenantId },
      params: {
        // tenantId,
        search,
        sort: 'asc',
        limit,
        offset,
        status: status,
      },
    }
  );
  return response.data as ChartOfAccountsResponse;
}

export async function createChartOfAccount(
  tenantId: string,
  input: CreateChartOfAccountInput
): Promise<any> {
  const response = await axiosInstance.post(
    '/api/v1/financial-settings/chart-of-account',
    input,
    {
      headers: { 'x-tenant-id': tenantId },
    }
  );
  return response.data;
}

export async function editChartOfAccount(
  id: string,
  tenantId: string,
  input: editChartOfAccountInput
): Promise<any> {
  const response = await axiosInstance.patch(
    `/api/v1/financial-settings/chart-of-account/${id}`,
    input,
    {
      headers: { 'x-tenant-id': tenantId },
    }
  );
  return response.data;
}

export async function updateCOAStatus(
  id: string,
  tenantId: string,
  status: string,
  createdByUserId: string
): Promise<any> {
  const response = await axiosInstance.patch(
    `/api/v1/financial-settings/chart-of-account/updateStatus/${id}`,
    {
      status: status,
      updatedByUserId: createdByUserId,
    },
    {
      headers: { 'x-tenant-id': tenantId },
    }
  );
  return response.data;
}

export async function bulkCreateChartOfAccount(
  tenantId: string,
  input: CreateChartOfAccountInput[]
): Promise<any> {
  const response = await axiosInstance.post(
    '/api/v1/financial-settings/chart-of-account/bulkCreate',
    input,
    {
      headers: { 'x-tenant-id': tenantId },
    }
  );
  return response.data;
}
